export const AppLinkURLS=[
    { 
        Country: 'DEFAULT' , 
        Partner: 'DEFAULT',
        Android_URL:'https://play.google.com/store/apps/details?id=au.com.universalpractice.mobile',
        IOS_URL:'https://apps.apple.com/au/app/universal-practice-app/id1567997954'
    }
];